import type { ReactNode } from 'react';
import type { LocationStatus } from '@interfaces/IScheduler';
import { AREA_MARK, type AreaMark } from '@d-orca/shared/client/activities';
import { GlyphCheck, GlyphFlag, GlyphHalfDisc, GlyphRing, GlyphSvg } from '@components/ui/StatusGlyphGeometry/StatusGlyphGeometry';

interface IStatusMarkProps {
  status: LocationStatus;
  size?: number;
}

/** Each mark at the weights that suit a saturated mark on a pale ground. */
const GLYPH: Record<AreaMark, ReactNode> = {
  check: <GlyphCheck strokeWidth={1.9} />,
  flag: <GlyphFlag strokeWidth={1.6} />,
  half: <GlyphHalfDisc strokeWidth={1.4} />,
  ring: <GlyphRing strokeWidth={1.4} />,
};

/** Crisp status mark over Trusstor's per-area vocabulary — which mark a status
 *  draws is the shared `AREA_MARK`: a ring (planned / unplanned), a half-filled
 *  disc (under way, delayed or awaiting review), a flag (overdue — the one late
 *  reading that has passed its date, which shares delayed's red and is told
 *  apart by the glyph) or a check (complete). Uses `currentColor`, so it
 *  inherits the cell/segment fg. The shapes are the shared
 *  `StatusGlyphGeometry`. */
export function StatusMark({ status, size = 13 }: IStatusMarkProps) {
  const mark = AREA_MARK[status];
  return <GlyphSvg size={size} mark={mark}>{GLYPH[mark]}</GlyphSvg>;
}
